module.exports = "/images/dummy-img.png?22f340f0106de8ca863adacd9e2d5a0f";